export default __webpack_public_path__ + "static/media/chat.061989ce.svg";